import { render } from "./HumanAEModal.vue?vue&type=template&id=90566162&ts=true"
import script from "./HumanAEModal.vue?vue&type=script&lang=ts"
export * from "./HumanAEModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__